import { resolveRuntimeContext } from './resolver';
import type { RuntimeContext, RuntimeResolveIssue, RuntimeResolveResult } from './types';
import { clearRuntimeOverrideCookie, readRuntimeSources, type RuntimeSourceInput } from './sources';
import { reportDegradation } from '@/mod/monitoring/diagnostics';

let cachedResolution: RuntimeResolveResult | undefined;
let fallbackReported = false;

function formatFallbackDetail(issues: readonly RuntimeResolveIssue[]): string {
  return issues.map(issue => (issue.detail ? `${issue.code}:${issue.detail}` : issue.code)).join('|');
}

function reportResolution(result: RuntimeResolveResult): void {
  if (result.issues.length === 0 || fallbackReported) return;
  fallbackReported = true;
  reportDegradation({
    code: 'RUNTIME_CONTEXT_FALLBACK',
    source: 'environment',
    detail: formatFallbackDetail(result.issues),
  });
}

function resolveAndHandleOverride(input: RuntimeSourceInput): RuntimeResolveResult {
  const result = resolveRuntimeContext(input);
  if (result.discardOverride) clearRuntimeOverrideCookie();
  reportResolution(result);
  return result;
}

export function initializeRuntimeContext(input?: RuntimeSourceInput): RuntimeResolveResult {
  if (!input && cachedResolution) return cachedResolution;
  const result = resolveAndHandleOverride(input || readRuntimeSources());
  cachedResolution = result;
  return result;
}

export function getRuntimeContext(): Readonly<RuntimeContext> {
  return initializeRuntimeContext().context;
}

export function resetRuntimeContextForTest(): void {
  cachedResolution = undefined;
  fallbackReported = false;
}
